import React from 'react';

type EventTypeLiteral =
  | "create_report"
  | "update_report"
  | "fill_element"
  | "edit_element"
  | "validate_element"
  | "create_source"
  | "approve_report"
  | "create_report_file"
  | "update_report_file"
  | "complete_report"
  | "reopen_report";

type Event = {
  id: string;
  created_at: string;
  user_name: string | null;
  user_email: string | null;
  event_type: EventTypeLiteral;
  message?: string | null;
  /**
   * Sui `fill_element` puo' arrivare il riuso di una generazione gia' calcolata
   * per gli stessi input: l'elemento non e' stato ricalcolato.
   */
  event_data?: {
    generation_id?: string;
    reused_from_id?: string;
    reused?: boolean;
  } | null;
};

type Props = {
  events: Event[];
};

// 🔹 Mappa dei literal con etichette leggibili
const getEventLabel = (eventType: EventTypeLiteral): string => {
  switch (eventType) {
    case "create_report": return "Creazione Report";
    case "update_report": return "Modifica Report";
    case "fill_element": return "Calcolo Driver";
    case "edit_element": return "Modifica Driver";
    case "validate_element": return "Validazione Driver";
    case "create_source": return "Creazione Fonte";
    case "approve_report": return "Validazione Report";
    case "create_report_file": return "Creazione Documento";
    case "update_report_file": return "Modifica Documento";
    case "complete_report": return "Chiusura Report";
    case "reopen_report": return "Riapertura Report";
    default: return eventType;
  }
};

const EventList: React.FC<Props> = ({ events }) => {
  if (!events || events.length === 0) {
    return (
      <div className="card-bg p-8 rounded-lg shadow-md mt-8">
        <h2 className="text-xl font-semibold text-textPrimary mb-6 font-heading">Attività</h2>
        <p className="text-textSecondary font-paragraph">
          Nessuna attività registrata per questo elemento.
        </p>
      </div>
    );
  }

  return (
    <details className="card-bg p-8 rounded-lg shadow-md mt-8 open">
      <summary className="cursor-pointer text-xl font-semibold text-textPrimary mb-6 font-heading">
        Attività
      </summary>
      <div className="space-y-4 mt-4">
        {[...events].map((event) => (
          <div
            key={event.id}
            className="border border-borderDivider rounded-md p-4 bg-white"
          >
            <p className="text-sm text-gray-500 mb-2">
              Ultima modifica: {new Date(event.created_at).toLocaleString('it-IT')}
            </p>
            <p className="font-semibold text-sm text-gray-600">
              {event.user_name || 'Utente sconosciuto'}
            </p>
            <p className="text-sm text-gray-600">
              Email: {event.user_email || 'non disponibile'}
            </p>
            <p className="text-sm text-gray-600 flex items-center gap-2">
              <span>Tipo evento: {getEventLabel(event.event_type)}</span>
              {event.event_data?.reused && (
                <span
                  title="Il risultato era già stato calcolato per gli stessi input: l'elemento non è stato ricalcolato."
                  className="px-2 py-0.5 rounded-full text-[11px] font-medium bg-gray-100 text-gray-600"
                >
                  riusato
                </span>
              )}
            </p>
            {event.message && (
              <p className="text-sm text-gray-700 mt-2">
                <span className="font-semibold">Dettagli:</span> {event.message}
              </p>
            )}
          </div>
        ))}
      </div>
    </details>
  );
};

export default EventList;
